<!--===========================
=            MODAL            =
============================-->

<template>
  <!-- Modals -->
  <v-container > <v-row no-gutters>
    <base-header>
      <div slot="page-header">Modals</div>
    </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">
            Basic Modal

          </div>

          <div slot="card-body">
            <modal></modal>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">
            Scrolling long content

          </div>
          <div slot="card-body">
            <without-activator></without-activator>
          </div>
        </base-card>
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">
            Vertically centered

          </div>
          <div slot="card-body">
            <overflowed-modals></overflowed-modals>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">
            Optional sizes

          </div>
          <div slot="card-body">
            <scrollable-modals></scrollable-modals>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Varying modal content</div>
          <div slot="card-body">
            <nested-dialogs></nested-dialogs>
          </div>
        </base-card>
      </v-col>

    </v-row>

  </v-container>

</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
  import FormModals from "../../components/Ui/Modals/FormModals.vue";
  import FullscreenModals from "../../components/Ui/Modals/FullscreenModals.vue";
  import LoaderModals from "../../components/Ui/Modals/LoaderModals.vue";
  import Modal from "../../components/Ui/Modals/Modal.vue";
  import NestedDialogs from "../../components/Ui/Modals/NestedDialogs.vue";
  import OverflowedModals from "../../components/Ui/Modals/OverflowedModals.vue";
  import ScrollableModals from "../../components/Ui/Modals/ScrollableModals.vue";
  import WithoutActivator from "../../components/Ui/Modals/WithoutActivator.vue";
  export default {
    components: {
      BaseCard,
      BaseHeader,
      FormModals,
      FullscreenModals,
      LoaderModals,
      Modal,
      NestedDialogs,
      OverflowedModals,
      ScrollableModals,
      WithoutActivator
    },
    data() {
      return {
        dialog: false,
        dialog2: false,
        dialog3: false,
        notifications: false,
        sound: true,
        widgets: false,
        items: [{
            title: "Click Me"
          },
          {
            title: "Click Me"
          },
          {
            title: "Click Me"
          },
          {
            title: "Click Me 2"
          }
        ],
        select: [{
            text: "State 1"
          },
          {
            text: "State 2"
          },
          {
            text: "State 3"
          },
          {
            text: "State 4"
          },
          {
            text: "State 5"
          },
          {
            text: "State 6"
          },
          {
            text: "State 7"
          }
        ]
      };
    }
  };
</script>

<!--====  End of MODAL  ====-->
